import { PlatformsHero } from "@/components/platformsHero/platformsHero.comp";
import { Layout } from "../../components/layout/layout.comp";
import { getDataFromDB } from "../../lib/mongodb";
import { IPlatform } from "../../types";
import { PlatformsBanner } from "@/components/platformsBanner/platformsBanner.comp";
import { PlatformCatalog } from "@/components/platformCatalog/platformCatalog.comp";

export default function PlatformsPage({
  platforms,
}: {
  platforms: IPlatform[];
}) {
  return (
    <Layout
      isDark
      showHeader={true}
      showFooter={true}
      title="Add a Bracket Maker to Any Platform | Brackets Ninja"
      description="Add Brackets Ninja's bracket maker to any website builder or store platform, Wix, WordPress, Shopify, Squarespace and hundreds more. No coding required."
      url={`https://www.bracketsninja.com/platforms`}
    >
      <PlatformsHero />
      <PlatformCatalog platforms={platforms} />
      <PlatformsBanner
        img="/assets/platforms-banner.webp"
        alt="floating platform icons"
        mode="dark"
        title="Multi-Platform Compatibility"
        text="There are over hundreds of available website builders, e-commerce platforms, landing page builders, and blog builders out there, and Common Ninja’s widgets work on all of them - no matter what platform you are using to build your website or e-commerce store."
      />
    </Layout>
  );
}

export async function getStaticProps() {
  const platforms = await getDataFromDB<IPlatform>("platforms", {
    status: "published",
  });

  return {
    props: { platforms },
  };
}
